import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'common-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  //   styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  @Input() link: any = {};
  @Input() compareFn = function () {
    return 0;
  }
  constructor(public router: Router,
  ) { }




  ngOnInit(): void {
    // console.log(this.link)
  }

  navigateRoute(path) {
    console.log("path=====",path);
    this.router.navigate([path]);
  }

}